import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import AdminLayout from '@/layouts/AdminLayout.vue'
import WorkbenchPage from '@/pages/WorkbenchPage.vue'
import ModulePage from '@/pages/ModulePage.vue'
import AIStudioPage from '@/pages/AIStudioPage.vue'
import CockpitPage from '@/pages/CockpitPage.vue'
import MobileLayout from '@/layouts/MobileLayout.vue'
import MobileHome from '@/pages/mobile/MobileHome.vue'
import MobileSection from '@/pages/mobile/MobileSection.vue'
import MobileAI from '@/pages/mobile/MobileAI.vue'
import FieldServicePage from '@/pages/mobile/FieldServicePage.vue'
import { menuGroups } from '@/config/menu'

export const desktopRoutes: RouteRecordRaw[] = menuGroups.flatMap(menu =>
  menu.children.map(page => ({
    path: `/${menu.id}/${page.id}`,
    name: `${menu.id}-${page.id}`,
    component: menu.id === 'workbench' && page.id === 'p1' ? WorkbenchPage : menu.id === 'ai' ? AIStudioPage : menu.id === 'cockpit' ? CockpitPage : ModulePage,
    meta: { menuId:menu.id, pageId:page.id, title:`${page.label} - ${menu.label}`, status:page.status }
  }))
)

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    { path:'/', redirect:() => typeof window !== 'undefined' && window.innerWidth <= 768 ? '/mobile/home' : '/workbench/p1' },
    { path:'/', component:AdminLayout, children:desktopRoutes },
    { path:'/mobile', component:MobileLayout, redirect:'/mobile/home', children:[
      { path:'home', name:'home', component:MobileHome },
      { path:'service', name:'service', component:MobileSection },
      { path:'circle', name:'circle', component:MobileSection },
      { path:'ai', name:'mobile-ai', component:MobileAI },
      { path:'profile', name:'profile', component:MobileSection }
    ]},
    { path:'/mobile/field-service', component:FieldServicePage },
    { path:'/:pathMatch(.*)*', redirect:'/workbench/p1' }
  ],
  scrollBehavior: () => ({ top:0 })
})

router.afterEach(to => { document.title = String(to.meta.title ?? '高素质农民智能服务平台') })

export default router
